import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "vector",
      d: "M9.0013 5.00008L5.0013 9.00008M9.0013 9.00008L5.0013 5.00008M13.3346 7.00008C13.3346 10.4979 10.4991 13.3334 7.0013 13.3334C3.5035 13.3334 0.667969 10.4979 0.667969 7.00008C0.667969 3.50228 3.5035 0.666748 7.0013 0.666748C10.4991 0.666748 13.3346 3.50228 13.3346 7.00008Z",
      stroke: "#F18169",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }